<template>
    <section :class="classes" v-show="visible">
        <div
            :class="[mdsNS('overlay'), namespace('overlay')]"
            v-if="showOverlay"
        ></div>
        <div
            :class="[mdsNS('loader'), namespace('loader')]"
            v-show="visible"
            role="progressbar"
            :aria-valuetext="ariaText"
        >
            <div :class="mdsNS('loader__item loader__item--1')"></div>
            <div :class="mdsNS('loader__item loader__item--2')"></div>
            <div :class="mdsNS('loader__item loader__item--3')"></div>
            <div :class="mdsNS('loader__item loader__item--4')"></div>
            <div :class="mdsNS('loader__item loader__item--5')"></div>
            <div :class="mdsNS('loader__item loader__item--6')"></div>
            <div :class="mdsNS('loader__item loader__item--7')"></div>
            <div :class="mdsNS('loader__item loader__item--8')"></div>
        </div>
    </section>
</template>
<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-loading',
    mixins: [mixins],
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        showOverlay: {
            type: Boolean,
            default: false
        },
        ariaText: {
            type: String,
            default: 'Loading...'
        }
    },
    created() {
        this.namespace = utils.namespace('ui-loading', false);
    },
    computed: {
        classes() {
            const cls = [this.namespace()];
            if (this.skin) {
                cls.push(
                    `${this.namespace()}__${utils.getSkinSuffix(this.skin)}`
                );
            }
            return cls;
        }
    }
};
</script>

<style lang="scss">
$namespace: 'markets-ui-loading';
.#{$namespace} {
    position: absolute;
    width: 80px;
    top: calc(50% - 40px);
    left: calc(50% - 40px);
    font-size: 2px;
    z-index: 100;
    &-overlay {
        background: #fff;
        opacity: 0.3;
    }
    &-loader {
        z-index: 810;
    }
    &__dark-gray {
        .#{$namespace}-overlay {
            background: #000;
            opacity: 0.3;
        }
    }
}
</style>
